const apiV1 = 'api/v1';
const fbManager = 'api/v1/facebook_manager';
const cabinet = `${fbManager}/cabinet`;

export default {
  cabinet,
  adsHistory: `${cabinet}/ads-history`,
  accounts: `${cabinet}/accounts`,
  accountsDetails: `${cabinet}/accounts-details`,
  accountsGroups: `${cabinet}/accounts-groups`,
  apps: `${cabinet}/apps`,
  statuses: `${cabinet}/statuses`,
  packs: `${cabinet}/packs`,
  uniqueId: `${apiV1}/unique-id`,
  flows: `${cabinet}/flows`,
  flowDetails: `${cabinet}/flow-details`,
  facebookPages: `${cabinet}/facebook-pages`,
  facebookPageDetails: `${cabinet}/facebook-page-details`,
  creativeTexts: `${cabinet}/creative-texts`,
  users: `${cabinet}/users`,
  userDetails: `${cabinet}/users-details`,
  goToTest: `${cabinet}/go-to-test`,
  goToTestDetails: `${cabinet}/go-to-test-details`,
};
